// SPDX-FileCopyrightText: 2017-2022 City of Espoo
//
// SPDX-License-Identifier: LGPL-2.1-or-later

export type MobileMode = 'list' | 'map'

export const mapViewBreakpoint = '900px'
